import { render, staticRenderFns } from "./LInfoBox.vue?vue&type=template&id=f903ecfe&"
import script from "./LInfoBox.vue?vue&type=script&lang=js&"
export * from "./LInfoBox.vue?vue&type=script&lang=js&"
import style0 from "./LInfoBox.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports